import { getAuth, signOut } from "firebase/auth";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../AuthProvider/AuthProvider";
import CustomLink from "../Component/CustomLink/CustomLink";
import app from "../firebase/firebase.config";
import "./Header.css";

const auth = getAuth(app);

const Header = () => {
  const [search, setSearch] = useState("");
  const searchValue = (e) => {
    setSearch(e.target.value);
  };
  const [error, setError] = useState();
  const { user } = useContext(AuthContext);

  const handleSignOut = () => {
    signOut(auth)
      .then(alert("log out successfully."))
      .catch((err) => console.log(err.message));
  };

  return (
    <div>
      <div className="navbar p-4 bg-indigo-700 text-white">
        <div className="navbar-start">
          <div className="list-none gap-8 pl-6 hidden md:flex">
            <li className="text-white text-lg hover:text-pink-400">
              <CustomLink to="/">Home</CustomLink>
            </li>
            <li className="text-white text-lg hover:text-pink-400">
              <CustomLink to="/playlist">Playlist</CustomLink>
            </li>
            <li className="text-white text-lg hover:text-pink-400">
              <CustomLink to="/videos">All Videos</CustomLink>
            </li>
            <li className="text-white text-lg hover:text-pink-400">
              <CustomLink to="/about">About</CustomLink>
            </li>
            <li className="text-white text-lg hover:text-pink-400">
              <CustomLink to="/blogs">Blogs</CustomLink>
            </li>
          </div>
          <div className="dropdown md:hidden">
            <label tabIndex={0} className="btn btn-ghost btn-circle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content  mt-3 p-2 shadow bg-indigo-600 rounded-box w-52"
            >
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/">Home</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/playlist">Playlist</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/videos">All Videos</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/about">About</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/blogs">Blogs</CustomLink>
              </li>
              {!user ? (
                <>
                  <li className="text-white text-lg hover:text-pink-400">
                    <CustomLink to="/login">Login</CustomLink>
                  </li>
                  <li className="text-white text-lg hover:text-pink-400">
                    <CustomLink to="/Signup">Sign up</CustomLink>
                  </li>
                </>
              ) : (
                <>
                  <li
                    onClick={handleSignOut}
                    className="text-white text-lg hover:text-pink-400"
                  >
                    <p className="font-semibold">Log out</p>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
        <div className="navbar-center">
          <a
            href="https://youtube.com/c/OnlineITGhor"
            target="blank"
            className="btn btn-ghost normal-case text-2xl"
          >
            Online It Ghor
          </a>
        </div>
        <div className="navbar-end">
          <div className="dropdown dropdown-end md:hidden">
            <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <div className="input-group ">
                  <input
                    onChange={searchValue}
                    type="text"
                    placeholder="Search video..."
                    className="input  input-sm w-32 max-w-xs bg-white text-black"
                  />
                  <Link to={`/searchVideo/${search}`}>
                    <button className="rounded h-full bg-black text-white px-2 py-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </button>
                  </Link>
                </div>
              </li>
            </ul>
          </div>

          {/* ------------Search field------------- */}

          <div className=" xl:w-70 md:w-56 block md:hidden items-center mr-5"></div>
          <div className="form-control hidden md:block">
            <div className="input-group ">
              <input
                onChange={searchValue}
                type="text"
                placeholder="Search video..."
                className="input input-sm w-30 max-w-xs bg-white text-black"
              />
              <Link to={`/searchVideo/${search}`}>
                <button className="rounded h-full bg-black text-white px-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </Link>
            </div>
          </div>

          {/* ------------------------------ */}

          {!user ? (
            <>
              <Link
                to={"/login"}
                className="btn btn-sm pt-2  bg-white text-blue-800 hover:text-white ml-2 md:block hidden"
              >
                Login
              </Link>
              <Link
                to={"/signup"}
                className="btn btn-sm pt-2 bg-white text-blue-800 hover:text-white ml-2 md:block hidden"
              >
                Sign up
              </Link>
            </>
          ) : (
            <>
              <button
                onClick={handleSignOut}
                className="btn btn-sm bg-white text-blue-800 hover:text-white ml-2 md:block hidden"
              >
                Log Out
              </button>
              <div className="avatar online placeholder w-8 h-8 md:ml-4">
                <div className=" bg-white text-neutral-content rounded-full w-16">
                  <span className="text-xl text-black">R</span>
                </div>
              </div>
            </>
          )}
        </div>
        {/* {user && (
          <div className="avatar online placeholder w-8 h-8">
            <div className="bg-neutral-focus text-neutral-content rounded-full w-16">
              <span className="text-xl">JO</span>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default Header;
